import isdlAccessInstance from './isdlAccessInstance';

//GET

//Countries_GetVenue
export const getVenue = async (country, venue) => await isdlAccessInstance.countryData.GetVenue(country, venue);

//Countries_SearchForVenues
export const getVenueWithSearch = async (country, potentialVenue) => await isdlAccessInstance.countryData.GetVenueWithSearch(country, potentialVenue);


//POST

//UTILITIES
export async function GetVenueAdjustments(venueName, sessionDate){
  let venue = null;
  
  try{
    venue = await getVenue("USA", venueName);
  }catch(e){

  }

  let adjData = {
    deg:0,
    x:0,
    z:0,
    bgImg:'https://isdlapps.blob.core.windows.net/lmreceiver/WebImages/ECPC_01.png'
  };

  //Still have to add date range for session to pick the right data.
  if(venue && venue.hasOwnProperty('TopTracerSetup') && (sessionDate !== null && sessionDate !== undefined)){
    let topTracerSetup = venue['TopTracerSetup'];

    if(topTracerSetup){
      const adjustmentData = getLastOccurredObject(sessionDate, topTracerSetup);
      adjData.bgImg = adjustmentData.ImageUrl;
      adjData.deg = adjustmentData.Rotation;
      adjData.x = adjustmentData.X_Offset;
      adjData.z = adjustmentData.Z_Offset;
    }
  }
  
  return adjData;
}

function getLastOccurredObject(referenceDateStr, objects) {
  // Convert reference date string to Date object
  const referenceDate = new Date(referenceDateStr);

  // Filter out objects where the Date is in the future
  const pastDates = objects
      .map(obj => ({ ...obj, Date: new Date(obj.Date) })) // Convert string dates to Date objects
      .filter(obj => obj.Date <= referenceDate); // Keep only past dates

  // Find the latest date from the past dates
  if (pastDates.length === 0) return null; // No past dates found

  return pastDates.reduce((latest, obj) => obj.Date > latest.Date ? obj : latest);
}

function formatDateLocal() {
  const date = new Date();
  const timezoneOffset = -date.getTimezoneOffset(); // Offset in minutes
  const offsetHours = String(Math.floor(timezoneOffset / 60)).padStart(2, '0');
  const offsetMinutes = String(timezoneOffset % 60).padStart(2, '0');
  const offsetSign = timezoneOffset >= 0 ? '+' : '-';
  
  const localISO = date.getFullYear() +
      '-' + String(date.getMonth() + 1).padStart(2, '0') +
      '-' + String(date.getDate()).padStart(2, '0') +
      'T' + String(date.getHours()).padStart(2, '0') +
      ':' + String(date.getMinutes()).padStart(2, '0') +
      ':' + String(date.getSeconds()).padStart(2, '0') +
      offsetSign + offsetHours + ':' + offsetMinutes;

  return localISO;
};